<template>
  <v-card class="rounded-card card-shadow">
    <v-card-text>
      <v-row dense>
        <v-col cols="12" sm="6" md="7">
          <p class="mb-1">
              <span class="headline font-weight-bold text--primary">
                {{ nomeFornecedor }}
              <px-popover-fornecedor :fornecedor-id="compra.fornecedor.id" show-score />
              </span>
          </p>
        </v-col>
        <v-col cols="12"
               sm="6"
               md="5"
               class="text-right">
          <template v-if="hasRoleComprador">
            <px-compra-aprove-dialog
              v-if="isPendente && !isRecusadoCancelado && isAtrasado"
              :compraId="compra.id"
              @movimentar="onMovimentar"/>
            <px-compra-enviar-ordem-dialog
              v-if="isPendenteComprador"
              :compra="compra"
              @movimentar="onMovimentar"/>
          </template>
          <template v-if="hasRoleGestorCompras || hasRoleComprador">
            <px-detalhes-compra-menu :compra="compra" @change="onMovimentar"/>
          </template>
        </v-col>
      </v-row>
      <v-row dense no-gutters class="mb-2">
        <v-col cols="12">
          <px-situacao-compra-tag chip-class="mr-2" :situacao="compra.situacao"/>
          <px-entrega-menu v-if="hasControleEntrega && !isRecusadoCancelado"
                           :item="compra"
                           :has-role-gestor-entrega="hasRoleGestorEntrega"
                           @change-data-entrega="updatePrevisaoEntrega"
                           @change-entrega="finalizarEntrega">
            <template v-slot:activator="{ on }">
              <px-situacao-entrega-compra v-on="on"
                                          :situacao="compra.situacaoEntrega"/>
            </template>
          </px-entrega-menu>
          <px-indicador-recebimento :compra="compra"/>
        </v-col>
      </v-row>
      <p class="subtitle-card-detail">
        <v-icon>mdi-pound</v-icon>
        <px-span-tooltip
          bottom
          :text="textCodigoCompra"
          :tooltip="tooltipCodigoCompra"/>
      </p>
      <p class="subtitle-card-detail">
        <v-icon>mdi-domain</v-icon>
        <px-fornecedor-documento :fornecedor="compra.fornecedor"/>
      </p>
      <p class="subtitle-card-detail">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-icon>mdi-map-marker</v-icon>
              {{ endereco }}
            </span>
          </template>
          <span>Endereço do fornecedor</span>
        </v-tooltip>
      </p>
      <p class="subtitle-card-detail">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-icon>mdi-calendar</v-icon>
              {{ compra.dataCompra | date }}
            </span>
          </template>
          <span>Data da compra</span>
        </v-tooltip>
      </p>
      <p class="subtitle-card-detail" v-if="compra.codigoInternoFornecedor">
        <v-icon>mdi-alpha-c-box-outline</v-icon>
        <px-span-tooltip
          bottom
          :text="compra.codigoInternoFornecedor"
          tooltip="Código interno do fornecedor"/>
      </p>
      <div class="text--primary">
        <v-row dense>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Tipo de frete</span>
            <div>
              {{ compra.frete.tipoFrete }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Previsão de entrega</span>
            <div>
              {{ compra.dataPrevisaoEntrega | date | naoInformado }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Data de entrega solicitante</span>
            <div>
              {{ compra.dataNecessidadeEntregaSolicitacao | date | naoInformado}}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Data de Faturamento</span>
            <div>
              {{ compra.dataFaturamento | date | naoInformado }}
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Forma de pagamento</span>
            <div>
              <px-forma-pagamento :forma-pagamento="compra.formaPagamento"
                                  :prazo-pagamento="compra.prazoPagamento"/>
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Modo de pagamento</span>
            <div>
              {{ modoPagamento | naoInformado }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Observações internas</span>
            <div>
              <px-show-large-text :large-text="compra.observacao"/>
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Mensagem para o fornecedor</span>
            <div>
              <px-show-large-text :large-text="compra.mensagem"/>
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Projeto</span>
            <div>
              {{ projeto | naoInformado }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Centro de custo</span>
            <div>
              {{ centroCusto | naoInformado | truncate(40)}}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Mensagem para o comprador</span>
            <div>
              <px-show-large-text :large-text="compra.mensagemFornecedor"/>
            </div>
          </v-col>
          <v-col cols="12" sm="3" v-if="hasTransport">
            <span class="caption font-weight-bold">Transportadora</span>
            <div>
              {{ nomeTransportador }}
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="3" v-if="compra.usuario">
            <span class="caption font-weight-bold">Responsável</span>
            <div>
              {{ compra.usuario.nome }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Finalidade da Compra</span>
            <div v-if="compra.finalidadeCompra">
              <px-finalidade-compra-value :finalidade-compra="compra.finalidadeCompra"/>
            </div>
            <div v-else>
              Não Informado
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Observação do frete</span>
            <div>
              <px-show-large-text :large-text="compra.frete.observacaoFrete"/>
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Anexos</span>
            <div v-if="compra.arquivos.length">
              <px-anexo-chip :files="compra.arquivos"
                             download-base-path="files/download-comprador"/>
            </div>
            <div v-else>
              Nenhum anexo informado
            </div>
          </v-col>
          <v-col cols="12" sm="3" v-if="isRecusadoCancelado">
            <span class="caption font-weight-bold">Motivo da recusa/cancelamento</span>
            <div>
              <px-show-large-text v-if="compra.motivoRecusa" :large-text="compra.motivoRecusa"/>
              <span v-else>Acesse o detalhe do item para saber o motivo
                <br>da recusa/cancelamento.</span>
            </div>
          </v-col>
          <v-col cols="12" sm="3" v-if="compra.tipoNotaEntrada">
            <span class="caption font-weight-bold">Tipo de nota de entrada</span>
            <div>
              {{ compra.tipoNotaEntrada.descricao }}
            </div>
          </v-col>
        </v-row>
          <px-campos-integracao v-if="cadastrosAdicionais"
                                type="compra-view"
                                :form-data="cadastrosAdicionais"/>
        <v-row dense>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Número da nota fiscal</span>
            <div class="d-flex align-center">
              <px-compra-numero-nota-fiscal :disabled="!hasRoleComprador"
                                            :compra="compra"
                                            small/>
              <px-anexo :max="1"
                        title="Nota fiscal"
                        :disabled="loadingNotaFiscal"
                        empty-button-text="Nota fiscal"
                        v-model="compra.notaFiscalFile"
                        download-base-path="files/download-comprador"
                        @loading="onNotaFiscalLoading"
                        @remove="onRemoveNotaFiscal">
                <template v-slot:activator="{ on }">
                  <v-btn icon
                         small
                         :disabled="!hasRoleComprador"
                         v-on="on">
                    <v-icon size="20">mdi-paperclip</v-icon>
                  </v-btn>
                </template>
              </px-anexo>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
    <px-confirm-dialog ref="confirm"/>
  </v-card>
</template>

<script>
import { SituacaoCompra, TipoFrete, SituacaoEntregaCompra } from 'px-business-components';
import CompraService from '@/modules/compra/compra-service';
import { mapGetters } from 'vuex';
import { cadastrosAdicionaisToMap } from '@/utils/campos-integracao-utils';
import { descWithCodigoInterno } from '@/utils/object-utils';
import { computeEndereco } from '@/utils/endereco-utils';
import CompraNumeroNotaFiscal from '@/modules/compra/detalhes/CompraNumeroNotaFiscal.vue';
import CompraEnviarOrdemDialog from '../CompraEnviarOrdemDialog.vue';
import IndicadorRecebimento from '../IndicadorRecebimento.vue';
import CompraAproveDialog from '../CompraAproveDialog.vue';
import DetalhesCompraMenu from './DetalhesCompraMenu.vue';

export default {
  props: {
    compra: Object,
  },
  data() {
    return {
      loadingNotaFiscal: false,
      loadingCancelar: false,
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador', 'hasRoleGestorEntrega', 'hasRoleGestorCompras']),
    ...mapGetters('entidade', ['hasControleEntrega']),
    centroCusto() {
      return this.compra.centroCusto
        ? descWithCodigoInterno(this.compra.centroCusto) : null;
    },
    projeto() {
      return this.compra.projeto ? descWithCodigoInterno(this.compra.projeto) : null;
    },
    modoPagamento() {
      return this.compra.modoPagamento ? this.compra.modoPagamento.descricao : null;
    },
    isPendenteComprador() {
      return this.compra.situacao === SituacaoCompra.keys.PENDENTE_COMPRADOR.key;
    },
    isAprovada() {
      return this.compra.situacao === SituacaoCompra.keys.APROVADA.key;
    },
    isPendente() {
      return this.compra.situacao === SituacaoCompra.keys.PENDENTE_COMPRADOR.key
        || this.compra.situacao === SituacaoCompra.keys.PENDENTE_FORNECEDOR.key;
    },
    isAtrasado() {
      return this.checkTempoSemAprovacao(this.compra) >= 1;
    },
    hideCancelado() {
      return this.compra.situacao === SituacaoCompra.keys.CANCELADA.key;
    },
    isRecusadoCancelado() {
      return this.compra.situacao === SituacaoCompra.keys.RECUSADA.key
        || this.compra.situacao === SituacaoCompra.keys.CANCELADA.key;
    },
    isCif() {
      return this.compra.frete.tipoFrete === TipoFrete.keys.CIF.key;
    },
    labelFrete() {
      return this.isCif ? 'Entrega' : 'Embarque';
    },
    hasTransport() {
      return this.compra.transportadora !== null;
    },
    cadastrosAdicionais() {
      if (!this.compra.cadastrosAdicionais || !this.compra.cadastrosAdicionais.length) {
        return null;
      }
      return cadastrosAdicionaisToMap(this.compra.cadastrosAdicionais);
    },
    tooltipCodigoCompra() {
      return this.compra.codigoInterno ? 'Pedido de OC gerada / Pedido Proxpect' : 'Pedido Proxpect';
    },
    textCodigoCompra() {
      return this.compra.codigoInterno ? `${this.compra.codigoInterno} / ${this.compra.id}` : this.compra.id;
    },
    endereco() {
      return computeEndereco(this.compra.fornecedor.endereco);
    },
    nomeFornecedor() {
      return this.compra.nomeInternoFornecedor || this.compra.fornecedor.pessoa.nome;
    },
    nomeTransportador() {
      return this.compra.nomeInternoTransportadora || this.compra.transportadora.pessoa.nome;
    },
  },
  methods: {
    onMovimentar() {
      this.$emit('movimentar');
    },
    onRemoveNotaFiscal() {
      this.updateNotaFiscalFile();
    },
    onNotaFiscalLoading(loading) {
      if (!loading) {
        this.updateNotaFiscalFile();
      }
    },
    buildNotaFiscalPayload() {
      return {
        id: this.compra.id,
        notaFiscalFile: this.compra.notaFiscalFile[0] || null,
      };
    },
    updateNotaFiscalFile() {
      this.loadingNotaFiscal = true;
      const toUpdate = this.buildNotaFiscalPayload();
      CompraService.updateNotaFiscal(toUpdate)
        .then(() => {
          const message = toUpdate.notaFiscalFile === null ? 'Nota fiscal removida' : 'Nota fiscal atualizada';
          this.$toast(message, { color: 'success' });
        })
        .finally(() => {
          this.loadingNotaFiscal = false;
        });
    },
    checkTempoSemAprovacao(compra) {
      const dataHoje = new Date();
      const dataCompra = new Date(compra.createdIn);
      const msPorDia = 24 * 60 * 60 * 1000;
      const diasSemAprovacao = (dataHoje.getTime() - dataCompra.getTime()) / msPorDia;
      return Math.floor(diasSemAprovacao, 1);
    },
    updatePrevisaoEntrega(item, dataPrevisao) {
      CompraService.savePrevisaoEntrega(this.compra.id, {
        dataPrevisaoEntrega: dataPrevisao,
      }).then(() => {
        this.compra.dataPrevisao = dataPrevisao;
        this.$toast('Data de entrega atualizada', { color: 'success' });
      });
    },
    finalizarEntrega() {
      CompraService.finalizarEntrega(this.compra.id).then(() => {
        this.compra.situacaoEntrega = SituacaoEntregaCompra.keys.ENTREGUE.key;
        this.$toast('Compra atualizada', { color: 'success' });
      });
    },
  },
  created() {
    this.compra.notaFiscalFile = this.compra.notaFiscalFile && this.compra.notaFiscalFile.id
      ? [this.compra.notaFiscalFile] : [];
  },
  components: {
    pxCompraEnviarOrdemDialog: CompraEnviarOrdemDialog,
    pxIndicadorRecebimento: IndicadorRecebimento,
    pxCompraAproveDialog: CompraAproveDialog,
    pxDetalhesCompraMenu: DetalhesCompraMenu,
    pxCompraNumeroNotaFiscal: CompraNumeroNotaFiscal,
  },
};
</script>
